const MAX_RECENT_LABELS = 3;

const storageKey = (orgId: string) => `recent-labels:${orgId}`;

export function getRecentLabelIds(orgId: string | undefined): string[] {
  if (!orgId) return [];
  try {
    const raw = localStorage.getItem(storageKey(orgId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed
          .filter((id): id is string => typeof id === 'string')
          .slice(0, MAX_RECENT_LABELS)
      : [];
  } catch {
    return [];
  }
}

/** Move a label to the front of the org's recently-used list (deduped, capped). */
export function pushRecentLabelId(
  orgId: string | undefined,
  labelId: string,
): void {
  if (!orgId) return;
  const next = [
    labelId,
    ...getRecentLabelIds(orgId).filter((id) => id !== labelId),
  ].slice(0, MAX_RECENT_LABELS);
  try {
    localStorage.setItem(storageKey(orgId), JSON.stringify(next));
  } catch {
    // ignore quota / serialization errors — recents are a convenience only
  }
}
